/**
 * Axios configuration with authentication support
 * Handles both cookies and localStorage token (Safari fallback)
 */
import axios from 'axios';

// Create axios instance with default config
const axiosInstance = axios.create({
  withCredentials: true,
});

// Request interceptor - add Authorization header if token exists
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('session_token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - handle errors
// NOTE: We do NOT auto-redirect on 401 here anymore
// The ProtectedRoute component handles auth redirects
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // Log auth errors but don't auto-redirect
    // Let the calling code handle the redirect if needed
    if (error.response?.status === 401) {
      console.warn('[Axios] 401 Unauthorized:', error.config?.url);
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;

// Helper functions for token management
export const setAuthToken = (token) => {
  if (token) {
    localStorage.setItem('session_token', token);
    console.log('[Auth] Token saved to localStorage');
  }
};

export const clearAuthToken = () => {
  localStorage.removeItem('session_token');
  console.log('[Auth] Token cleared from localStorage');
};

export const getAuthToken = () => {
  return localStorage.getItem('session_token');
};
